import React, { useState } from "react";
import styles from "./style.module.scss";
import { ActionButton, Icon, Modal } from "@fluentui/react";
import { useForm } from "react-hook-form";
import { ControlledTextField } from "../ControlledTextField";
import { toast } from "react-toastify";
const CONTROL = {
  Name: "",
  DisplayName: "",
};

const CreateSecurityGroup = ({
  open,
  handleClose,
  onSuccess,
  createMutation,
  updateMutation,
  groupRecord,
}) => {
  const [isEditable, setIsEditable] = useState(false);
  const [controls, setControl] = useState({ ...CONTROL });
  const [disabled, setDisabled] = useState(false);
  const changeCursor = (prevState) => {
    if (prevState === "wait") {
      document.body.style.cursor = "wait";
    } else {
      document.body.style.cursor = "default";
    }
  };

  const { control, handleSubmit, setValue, reset } = useForm({
    defaultValues: {
      Name: "",
      DisplayName: "",
    },
  });

  React.useEffect(() => {
    if (!groupRecord.id) {
      setIsEditable(false);
      setControl({ ...CONTROL });
      Object.keys(controls).forEach((i) => {
        setValue(i, "");
      });
    }
  }, []);


  React.useEffect(() => {
    if (groupRecord.id) {
      reset();
      setIsEditable(true);
      controls.Name = groupRecord.internalName;
      controls.DisplayName = groupRecord.displayName;
      setControl({ ...controls });
      Object.keys(controls).forEach((i) => {
        setValue(i, controls[i]);
      });
    }
  }, [groupRecord.id]);
  const onSubmit = (data) => {
    setDisabled(true);
    changeCursor("wait");
    const payload = {
      InternalName: data.Name,
      DisplayName: data.DisplayName,
    };
    if (!isEditable)
      createMutation.mutate(payload, {
        onSuccess: () => {
          onSuccess();
          setDisabled(false);
          changeCursor("");
        },
        onError: (error) => {
          toast.error(
            error.message || "Something went wrong in security group creation"
          );
          setDisabled(false);
          changeCursor("");
        },
      });
    else {
      updateMutation.mutate(payload, {
        onSuccess: () => {
          onSuccess();
          setDisabled(false);
          changeCursor("");
        },
        onError: (error) => {
          toast.error(
            error.message || "Something went wrong in security group  updation"
          );
          setDisabled(false);
          changeCursor("");
        },
      });
    }
  };
  return (
    <Modal
      isOpen={open}
      onDismiss={handleClose}
      dragOptions={{ dragHandleSelector: "form" }}
    >
      {/* <ToastContainer /> */}
      <form
        className={styles.wrapper}
        onSubmit={handleSubmit(onSubmit)}
        id={"formId"}
      >
        <div className={styles.header}>
          <h4 className={styles.title}>{isEditable ? "Edit" : "Add"} Security Group </h4>
          <Icon
            iconName={"Cancel"}
            className={styles.close}
            onClick={handleClose}
          ></Icon>
        </div>

        <div className={styles.body}>
          <div className={styles.form}>
            <div className={styles.formGroup}>
              <h5 className={styles.groupTitle}>Security Group Details</h5>

              <div className={styles.field}>
                <ControlledTextField
                  required={true}
                  label="Internal Name"
                  name="Name"
                  disabled={groupRecord.id!=null}
                  control={control}
                  rules={{ required: "This field is required",pattern:{value:/^[a-zA-Z0-9--]+$/,message:"Only alphanumeric and hyphens allowed"}}}
                />
              </div>
              <div className={styles.field}>
                <ControlledTextField
                  required={true}
                  label="Display Name"
                  name="DisplayName"
                  control={control}
                  rules={{ required: "This field is required" }}
                />
              </div>

            </div>
          </div>
        </div>

        <div className={styles.footer}>
          <ActionButton disabled={disabled} type="submit" form="formId">
            Submit
          </ActionButton>
        </div>
      </form>
    </Modal>
  );
};

export default CreateSecurityGroup;
